// privacyItems は Q4CL-console の Q4CLSettings.js と完全に一致させること
// (旧 Q4CL-client/Q4CLSettings.js からの移植)
;(function () {
  window.Q4CL = {
    privacyItems: [
      { name: 'ptId', dispname: '診察券番号', type: 'text', sortable: true },
      { name: 'ptName', dispname: '氏名', type: 'text', sortable: true, default: true, autocomplete: 'name' },
      { name: 'ptNameKana', dispname: '氏名かな', type: 'text', sortable: true },
      { name: 'ptBirth', dispname: '生年月日', type: 'date', sortable: true, autocomplete: 'bday' },
      {
        name: 'ptSex',
        dispname: '性別',
        type: 'radio',
        inline: true,
        selector: '男性|女性|その他',
        sortable: true,
        autocomplete: 'sex'
      },
      { name: 'ptAddress', dispname: '住所', type: 'text', sortable: true },
      { name: 'ptPhone', dispname: '電話番号', type: 'text', autocomplete: 'tel' },
      { name: 'ptEmail', dispname: 'メールアドレス', type: 'text', autocomplete: 'email' }
    ]
  };

  window.Q4CL.privacyItemNames = window.Q4CL.privacyItems.map((x) => x.name);
})();
